import React, { useCallback, useEffect, useState } from 'react';
import { refreshTokenAPI } from '../../Modules/@Forms/SignInFormModule/Api/SignInAPI';
import { urlManager } from '../../Utils/URL/URLManager';
import { useNavigate } from 'react-router-dom';
import {
  getAuthTokenDurationStorage,
  getAuthTokenStorage,
  updateAuthTokenDurationStorage,
  updateAuthTokenStorage,
} from '../../Utils/Auth';

interface Props extends React.PropsWithChildren {}

const SAFE_SHIFT_DURATION = 60000; // 1m

const AuthRefreshProvider: React.FC<Props> = ({ children }) => {
  const [tokenDuration, setTokenDuration] = useState<number>(
    Number(getAuthTokenDurationStorage()) - SAFE_SHIFT_DURATION,
  );

  const navigate = useNavigate();
  const [abortController, setAbortController] = useState<AbortController>();

  const refreshHandler = useCallback(() => {
    const token = getAuthTokenStorage();

    if (!token || token === '') {
      navigate(urlManager.signIn());
    }

    abortController &&
      refreshTokenAPI(String(token), {
        signal: abortController.signal,
      })
        .then(r => {
          if (r.token) {
            const tokenDuration = Number(r.tokenDuration);
            updateAuthTokenStorage(r.token);

            updateAuthTokenDurationStorage(tokenDuration);
            setTokenDuration(tokenDuration - SAFE_SHIFT_DURATION);
          }
        })
        .catch(() => {
          navigate(urlManager.home());
        });
  }, [navigate, abortController]);

  useEffect(() => {
    refreshHandler();

    const id = setInterval(refreshHandler, tokenDuration);

    return () => {
      clearInterval(id);
    };
  }, [refreshHandler, tokenDuration]);

  useEffect(() => {
    const abortController = new AbortController();
    setAbortController(abortController);

    return () => {
      console.log('will unmount...');
      abortController.abort();
    };
  }, []);

  return <>{children}</>;
};

export default AuthRefreshProvider;
